import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-auto col-lg-8" };
const _hoisted_4 = { class: "col-auto col-lg-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "viewHospital",
            "no-footer": "",
            centered: "",
            size: "xl",
            title: _ctx.$t('JTADM_HOSPITALS_SHOW_HOSPITAL')
        }, {
            default: _withCtx(() => [
                ($setup.hospital)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode($setup["BContainer"], { fluid: "" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode($setup["HospitalSuggestion"], {
                                            "model-value": $setup.hospital,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.hospital) = $event)),
                                            "view-mode": ""
                                        }, null, 8, ["model-value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode($setup["CertificationSelector"], {
                                            "model-value": $setup.hospital.certification_ids,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.hospital.certification_ids) = $event)),
                                            "view-mode": ""
                                        }, null, 8, ["model-value"])
                                    ])
                                ])
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
